var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',_vm._g({class:['p-inputtextarea p-inputtext p-component', {'p-filled': _vm.filled, 'p-inputtextarea-resizable ': _vm.autoResize}],domProps:{"value":_vm.value}},_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }